import authReducer from './authReducer';
import floorReducer from './floorReducer';
import {combineReducers} from 'redux';


const rootReducer = combineReducers({
    auth : authReducer,
    floor : floorReducer
})

export default rootReducer